import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { DiffPercentageCore } from 'src/components/product-card/styles';
import CompareProductsToggleComponent from '../../../../components/compare-products-toggle';

export const ProductsWrapper = styled.div`
  padding-bottom: ${layout.measurements.spacing050};
`;

export const DiffPercentageRow = styled(DiffPercentageCore)`
  display: inline-block;
`;

export const CompareProductsToggle = styled(CompareProductsToggleComponent)`
  display: flex;
  flex: 0 1 auto;
`;
